import { render, staticRenderFns } from "./OpenBetsTab.vue?vue&type=template&id=c926cd4c&"
import script from "./OpenBetsTab.vue?vue&type=script&lang=js&"
export * from "./OpenBetsTab.vue?vue&type=script&lang=js&"
import style0 from "./OpenBetsTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports